import { render } from "./CardSurahSeparate.vue?vue&type=template&id=3ace85bf"
import script from "./CardSurahSeparate.vue?vue&type=script&lang=js"
export * from "./CardSurahSeparate.vue?vue&type=script&lang=js"
script.render = render

export default script